import { motion } from "framer-motion";

export const fadeUp = {
  hidden: { opacity: 0, y: 48, filter: "blur(8px)" },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: { duration: 0.9, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const Reveal = ({ children, className = "", i = 0, ...props }) => (
  <motion.div
    className={className}
    variants={fadeUp}
    custom={i}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, margin: "-80px" }}
    {...props}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ kicker, title, sub, align = "left", testId }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {kicker && (
      <Reveal>
        <p className="font-display text-[11px] font-medium tracking-[0.45em] text-white/50 uppercase">{kicker}</p>
      </Reveal>
    )}
    <Reveal i={1}>
      <h2
        data-testid={testId}
        className="font-display mt-5 text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tighter leading-[1.02] text-white"
      >
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal i={2}>
        <p className="mt-6 text-base md:text-lg text-white/55 font-light leading-relaxed">{sub}</p>
      </Reveal>
    )}
  </div>
);
